module.exports = __webpack_public_path__ + "img/cooperative0_logo19.7e57cc4e.jpg";